import angular from 'angular';
import common from './common/realtime.common';
import components from './components/realtime.component';
import { createPnService } from './pn-factory';
export default angular
    .module('doxy.realtime', [common, components])
    .factory('pn', createPnService).name;
